import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "../../utils/toast";
import WorkWithUs from "../../components/sections/WorkWithUs";

const Login = () => {
  const [phone, setPhone] = useState("");
  const [useWhatsappOtp, setUseWhatsappOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGenerateOTP = async (e) => {
    e.preventDefault();
    if (!phone) {
      toast.error("Please enter phone number");
      return;
    }
    if (!/^\d{10}$/.test(phone)) {
      toast.error("Phone number must be 10 digits");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APP_DOMAIN}/api/customer/login`,
        { phone, use_whatsapp_otp: useWhatsappOtp ? 1 : 0, source: "website" },
      );

      if (response.data.status === true) {
        toast.success(response.data.message || "OTP sent successfully!");
        navigate("/login-otp", { state: { phone } });
      } else {
        toast.error(response.data.message || "Login failed");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors;
        Object.keys(errors).forEach((key) => {
          toast.error(errors[key][0]);
        });
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Server error. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="login_wrap">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="login_formMain">
                <div className="loginForm_inner">
                  <h2>Login</h2>

                  <div className="form-group mb-4">
                    <label>Enter Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="e.g. 9876543210"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      maxLength={10}
                    />
                  </div>
                  <div className="form-group mb-4">
                    <div className="form-check d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="use_whatsapp_otp"
                        id="use_whatsapp_otp"
                        className="form-check-input"
                        style={{ width: "14px", height: "14px" }}
                        checked={useWhatsappOtp}
                        onChange={(e) =>
                          setUseWhatsappOtp(e.target.checked)
                        }
                      />
                      <label htmlFor="use_whatsapp_otp" className="ms-2 mb-0" style={{ fontSize: "14px" }}>
                        If your mobile is on DND, please select WhatsApp OTP option
                      </label>
                    </div>
                  </div>
                  <div className="login_btn mb-4">
                    <button
                      className="btn"
                      onClick={handleGenerateOTP}
                      disabled={loading}
                    >
                      {loading ? "Sending OTP..." : "Generate OTP"}
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WorkWithUs />
      <ToastContainer />
    </>
  );
};

export default Login;
